import { firstValueFrom } from 'rxjs';
import { MpsUserService } from '../services/mps-user.service';
import { MpsOauth2Service } from '../services/mps-oauth2.service';
import { MpsUser } from '../../app/models/mps-user.model';

export function mpsFetchBearer(oauth2service: MpsOauth2Service, userService: MpsUserService) {
  return (): void | Promise<MpsUser> => {
    const url = new URL(globalThis.location.href);
    const id = url.searchParams.get('_et');

    if (id) {
      return firstValueFrom(oauth2service.fetchToken(id)).then((response: { token: string }) => {
        localStorage.setItem('token', response.token);
        // Nettoyer l'URL et rediriger vers la page d'accueil
        globalThis.history.replaceState({}, '', '/');
        return firstValueFrom(userService.fetchUser());
      });
    }
  };
}
